module.exports = __webpack_public_path__ + "static/media/directorio-hombre-clipboard.0431e383.png";